"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unescape = exports.escapeHtml = void 0;
var escapeHtml = function (unsafe) {
    return unsafe
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
};
exports.escapeHtml = escapeHtml;
var unescape = function (string) {
    var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': '\'',
    };
    var reEscapedHtml = /&(?:amp|lt|gt|quot|#(0+)?39);/g;
    var reHasEscapedHtml = RegExp(reEscapedHtml.source);
    return string && reHasEscapedHtml.test(string)
        ? string.replace(reEscapedHtml, function (entity) { return htmlUnescapes[entity] || '\''; })
        : string || '';
};
exports.unescape = unescape;
//# sourceMappingURL=html.js.map